import React, { useEffect, useState, useMemo } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
// Pages
import Registration from "./registration/Registration";
import Login from "./login/Login";
import Verification from "./verification/Verification";
import RegistrationSuccess from "./registration-success/RegistrationSuccess";
import ChangePassword from "./change-password/ChangePassword";
// import { redirect } from "react-router-dom";
// import ProtectedRoute from "./core/components/ProtectedRoute";
import JointQuotation from "./quote/JointQuotation";
import Onboarding from "./onboarding/Onboarding";
// import SingleQuotationUnthenticated from "./quote/SingleQuotationUnauthenticated";
import SingleQuotationAuthenticated from "./quote/SingleQuotationAuthenticated";
import Quotations from "./quotations/Quotations";
import QuotationView from "./quotation-view/QuotationView";
import ResetPasswordRequest from "./reset-password-request/ResetPasswordRequest";
import ResetPassword from "./reset-password/ResetPassword";
import Policies from "./policies/Policies";
import Application from "./application/Application";
import Profile from "./profile/Profile";
import Underwriting from "./underwriting/Underwriting";
import EditQuotation from "./quote/EditQuotation";
// import Reflexes from "./underwriting/Reflexes";
import KYC from "./kyc/Kyc";
import ReviewAcceptanceAndSigning from "./review-acceptance-and-signing/ReviewAcceptanceAndSigning";
import InsurancePolicy from "./insurance-policy/InsurancePolicy";
import FirstPayment from "./payment/first-payment/FirstPayment";
import ShuftiRedirectPage from "./ShuftiRedirectPage";
import HasCompletedInitialSetup from "./core/components/HasCompletedInitialSetup";
import Clients from "./clients/Clients";
import ClientKyc from "./client-kyc/ClientKyc";
import LoggedInLayout from "./core/components/loggedin-layout/LoggedInLayout";
import coupleImage from "./core/assets/images/couple.png";
import graduationImage from "./core/assets/images/graduation.png";
import handsImage from "./core/assets/images/hands.png";
import dreamHomeImage from "./core/assets/images/dream-home.png";
import TerminalDisplay from "./underwriting/TerminalDisplay";
import MipsRedirectPage from "./MipsRedirectPage";
import UnderwritingSummaryPdfPage from "./underwriting/underwriting-summary-pdf-page/UnderwritingSummaryPdfPage";
import { ToastContainer } from "react-toastify";
// Local Storage
import UserContext from "./core/UserContext";
import { getUserDataFromLocalStorage } from "./core/utils";
// Auth Components
import PersistLogin from "./layouts/auth/PersistLogin";
import RequireAuth from "./layouts/auth/RequireAuth";
import FinancialUnderwriting from "./underwriting/FinancialUnderwriting";
import FinancialUnderwritingSummaryPdfPage from "./underwriting/financial-underwriting-summary-pdf-page/FinancialUnderwritingSummaryPdfPage";
import { useActiveView } from "./core/viewContext";
import FlexiSingleQuotationAuthenticated from "./quote/FlexiSingleQuotationAuthenticated";
import FlexiQuotations from "./quotations/FlexiQuotations";
import FlexiQuotationView from "./quotation-view/FlexiQuotationView";
import PolicyholderAccount from "./accounts/policyholderAccount";
import ViewAccount from "./accounts/viewAccount";
import FlexiEditQuotation from "./quote/FlexiEditQuotation";
import FlexiUnderwriting from "./underwriting/FlexiUnderwriting";
import FlexiFinancialUnderwriting from "./underwriting/FlexiFinancialUnderwriting";
import FlexiUnderwritingSummaryPdf from "./underwriting/underwriting-summary-pdf-page/FlexiUnderwritingSummaryPdf";
import FlexiApplication from "./application/FlexiApplication";
import FlexiFinancialUnderwritingSummaryPdf from "./underwriting/financial-underwriting-summary-pdf-page/FlexiFinancialUnderwritingSummaryPdf";
import FlexiReviewAcceptanceAndSigning from "./review-acceptance-and-signing/FlexiReviewAcceptanceAndSigning";
import FlexiFirstPayment from "./payment/first-payment/FlexiFirstPayment";
import FlexiPolicies from "./policies/FlexiPolicies";
import TransactionHistory from "./accounts/transactionHistory";

function App() {
  const [userData, setUserData] = useState(null);
  const providerValue = useMemo(
    () => ({ userData, setUserData }),
    [userData, setUserData]
  );

  useEffect(() => {
    const userDataFromLocalStorage = getUserDataFromLocalStorage();
    setUserData(userDataFromLocalStorage);
  }, []);

  const { activeView } = useActiveView();

  return (
    <>
      <UserContext.Provider value={providerValue}>
        <Routes>
          <Route
            path="/request-password-update"
            element={<ResetPasswordRequest />}
          />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Registration />} />
          <Route
            path="/successful-registration"
            element={<RegistrationSuccess />}
          />
          <Route path="/verification" element={<Verification />} />
          <Route path="/onboarding" element={<Onboarding />} />
          {/* <Route path="/quotation" element={<SingleQuotationUnthenticated />} /> */}

          <Route path="/shufti-redirect" element={<ShuftiRedirectPage />} />

          {/* We want to protect these routes */}
          <Route element={<PersistLogin />}>
            <Route path="/" element={<RequireAuth />}>
              <Route index element={<Navigate replace to="/quotations" />} />
              <Route path="/insurance-policy" element={<InsurancePolicy />} />
              <Route
                path="/change-password"
                element={<LoggedInLayout component={<ChangePassword />} />}
              />
              <Route
                path="/quotations/:quotationId/first-payment"
                element={
                  <LoggedInLayout
                    component={
                      activeView.loan ? <FirstPayment /> : <FlexiFirstPayment />
                    }
                  />
                }
              />
              <Route
                path="/underwriting/:quotationId/:life"
                element={
                  <LoggedInLayout
                    component={
                      <HasCompletedInitialSetup
                        component={
                          activeView.loan ? (
                            <Underwriting />
                          ) : (
                            <FlexiUnderwriting />
                          )
                        }
                      />
                    }
                  />
                }
              />
              <Route
                path="/financial-underwriting/:quotationId/:life"
                element={
                  <LoggedInLayout
                    component={
                      <HasCompletedInitialSetup
                        component={
                          activeView.loan ? (
                            <FinancialUnderwriting />
                          ) : (
                            <FlexiFinancialUnderwriting />
                          )
                        }
                      />
                    }
                  />
                }
              />
              <Route
                path="/underwriting-summary/:userId/:quotationId"
                element={
                  <LoggedInLayout
                    component={
                      <HasCompletedInitialSetup
                        component={
                          activeView?.loan ? (
                            <UnderwritingSummaryPdfPage />
                          ) : (
                            <FlexiUnderwritingSummaryPdf />
                          )
                        }
                      />
                    }
                  />
                }
              />
              <Route
                path="/financial-underwriting-summary/:userId/:quotationId"
                element={
                  <LoggedInLayout
                    component={
                      <HasCompletedInitialSetup
                        component={
                          activeView.loan ? (
                            <FinancialUnderwritingSummaryPdfPage />
                          ) : (
                            <FlexiFinancialUnderwritingSummaryPdf />
                          )
                        }
                      />
                    }
                  />
                }
              />
              <Route
                path="/kyc/:quotationId"
                element={<HasCompletedInitialSetup component={<KYC />} />}
              />
              <Route
                path="/client-kyc/:id/:quotationId/:life"
                element={
                  <LoggedInLayout
                    component={
                      <HasCompletedInitialSetup component={<ClientKyc />} />
                    }
                  />
                }
              />
              <Route
                path="/clients/:quotationId"
                element={
                  <LoggedInLayout
                    component={
                      <HasCompletedInitialSetup component={<Clients />} />
                    }
                  />
                }
              />
              <Route
                path="/review/:quotationId"
                element={
                  <LoggedInLayout
                    component={
                      <HasCompletedInitialSetup
                        component={
                          activeView.loan ? (
                            <ReviewAcceptanceAndSigning />
                          ) : (
                            <FlexiReviewAcceptanceAndSigning />
                          )
                        }
                      />
                    }
                  />
                }
              />
              <Route
                path="/create-quotation"
                element={
                  <LoggedInLayout
                    component={
                      <HasCompletedInitialSetup
                        component={
                          activeView.loan ? (
                            <SingleQuotationAuthenticated />
                          ) : (
                            <FlexiSingleQuotationAuthenticated />
                          )
                        }
                      />
                    }
                  />
                }
              />
              <Route
                path="/quotations"
                element={
                  <HasCompletedInitialSetup
                    component={
                      <LoggedInLayout
                        navImage={coupleImage}
                        component={
                          activeView?.loan ? (
                            <Quotations />
                          ) : (
                            <FlexiQuotations />
                          )
                        }
                      />
                    }
                  />
                }
              />
              <Route
                path="/joint-quote"
                element={
                  <HasCompletedInitialSetup component={<JointQuotation />} />
                }
              />
              <Route
                path="/quotations/:id"
                element={
                  <LoggedInLayout
                    navImage={handsImage}
                    component={
                      <HasCompletedInitialSetup
                        component={
                          activeView?.loan ? (
                            <QuotationView />
                          ) : (
                            <FlexiQuotationView />
                          )
                        }
                      />
                    }
                  />
                }
              />
              <Route
                path="/policies"
                element={
                  <LoggedInLayout
                    navImage={coupleImage}
                    component={
                      activeView?.loan ? <Policies /> : <FlexiPolicies />
                    }
                  />
                }
              />
              <Route
                path="/application"
                element={
                  <LoggedInLayout
                    navImage={graduationImage}
                    component={
                      <HasCompletedInitialSetup
                        component={
                          activeView.loan ? (
                            <Application />
                          ) : (
                            <FlexiApplication />
                          )
                        }
                      />
                    }
                  />
                }
              />
              <Route
                path="/accounts"
                element={
                  <LoggedInLayout
                    navImage={dreamHomeImage}
                    component={
                      <HasCompletedInitialSetup
                        component={<PolicyholderAccount />}
                      />
                    }
                  />
                }
              />
              <Route
                path="/accounts/:id"
                element={
                  <LoggedInLayout
                    navImage={dreamHomeImage}
                    component={
                      <HasCompletedInitialSetup component={<ViewAccount />} />
                    }
                  />
                }
              />
              <Route
                path="/accounts/transactions/:id"
                element={
                  <LoggedInLayout
                    navImage={dreamHomeImage}
                    component={
                      <HasCompletedInitialSetup
                        component={<TransactionHistory />}
                      />
                    }
                  />
                }
              />
              <Route
                path="/profile"
                element={
                  <LoggedInLayout
                    navImage={dreamHomeImage}
                    component={<Profile />}
                  />
                }
              />
              <Route
                path="/application-in-review"
                element={
                  <HasCompletedInitialSetup component={<TerminalDisplay />} />
                }
              />
              <Route path="/profile" element={<Profile />} />

              <Route
                path="/quotations/:id/edit"
                element={
                  <LoggedInLayout
                    navImage={dreamHomeImage}
                    component={
                      <HasCompletedInitialSetup
                        component={
                          activeView?.loan ? (
                            <EditQuotation />
                          ) : (
                            <FlexiEditQuotation />
                          )
                        }
                      />
                    }
                  />
                }
              />
              <Route
                path="/mips-redirect/:quotationId/:operationType/:paymentChannelId"
                element={
                  <HasCompletedInitialSetup component={<MipsRedirectPage />} />
                }
              />
              <Route
                path="/mips-redirect/:quotationId/:operationType/:paymentChannelId/:userId/:policyNumber/:amountExpected/:amountPaid/:internalPaymentReference"
                element={
                  <HasCompletedInitialSetup component={<MipsRedirectPage />} />
                }
              />
            </Route>
          </Route>
        </Routes>
      </UserContext.Provider>
      <ToastContainer />
    </>
  );
}

export default App;
